export const TRIP_CATEGORY_LABEL = "Drop-off at the same location";
export const CONTINUE = "Continue";
export const PICK_UP_LOCATION = "Pick-up location";
export const DROP_OFF_LOCATION = "Drop-off location";
export const RENTAL_CARS = "Rental Cars";
